module.exports = __webpack_public_path__ + "assets/not-wechat-bg-ef6b4284.png";